import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrl: './references.component.scss'
})
export class ReferencesComponent {
  form!: FormGroup;

  // 👇 Define dropdown options for Relation
  relationTypes: string[] = [
    'Father',
    'Mother',
    'Brother',
    'Sister',
    'Friend',
    'Colleague',
    'Relative',
    'Other'
  ];

  constructor(private fb: FormBuilder, private spinner: NgxSpinnerService, private finzyService: FinzyService, private router: Router) { }

  ngOnInit(): void {
    this.spinner.hide();
    this.form = this.fb.group({
      contactReferences: this.fb.array([this.createReferenceGroup(), this.createReferenceGroup()])
    });
  }

  createReferenceGroup(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      relation: ['', Validators.required],
      comments: ['']
    });
  }

  get contactReferences(): FormArray {
    return this.form.get('contactReferences') as FormArray;
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const isLetterOrSpace = /^[a-zA-Z ]$/.test(event.key);
    if (!isLetterOrSpace) {
      event.preventDefault();
    }
  }

  addReference(): void {
    this.contactReferences.push(this.createReferenceGroup());
  }

  removeReference(index: number): void {
    if (this.contactReferences.length > 2) {
      this.contactReferences.removeAt(index);
    }
  }

  async submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show();

    try {
      var res = await lastValueFrom(this.finzyService.UpdateReference(this.form.value));
      if (res['data']) {
        this.spinner.hide();
        this.router.navigateByUrl('/assist-journey/f/vkyc');
      }
      else if (res['error'] === "Rejected") {
        this.spinner.hide();
        return this.router.navigateByUrl('/assist-journey/sorry');
      }
      else {
        this.spinner.hide();
        swal.fire('Error', 'Something went wrong, please try again later');
      }
    }
    catch (err) {
      if (err?.status === 401) {
        this.spinner.hide();
        this.router.navigateByUrl('/assist-journey/session-expired');
      }

      if (err.status === 0) {
        this.spinner.hide();
        swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
        return;
      }
      console.log(err);
    }

    this.spinner.hide();
    console.log('Submitted JSON:', this.form.value);
  }
}
